__turbopack_context__.v({
  "className": "hypcMa_className",
  "variable": "hypcMa_variable",
});
